<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { ProjectProposalLifecycleSetterViewModel } from "@Quest/Projects/Components/ProjectProposalLifecycleSetter";


    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class ProjectProposalLifecycleSetter extends Vue
    {
        get vm(): ProjectProposalLifecycleSetterViewModel { return this.$props.viewModel as ProjectProposalLifecycleSetterViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }

        confirm()
        {
            this.$emit("confirm", this.vm.projectId);
        }

        close()
        {
            this.vm.close();
        }
    }

</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Revert Project Lifecycle to Proposal</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <p>
                            You are about to set the project lifecycle back to the <strong>Proposal</strong> stage. 
                        </p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" @click="close" class="btn btn-outline-secondary">Cancel</button>
                        <button type="button" @click="confirm" class="btn btn-primary">Confirm</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
